import React from "react";
import DetailWrapper from "../../components/detailWrapper";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { GoAlertFill } from "react-icons/go";
import { useTranslation } from "react-i18next";
import { Button } from "semantic-ui-react";
import { useNavigate } from "react-router";
import ResultPage from "../../components/ResultPage/ResultPage";

const PleaseSetUserIDCard = ({ children }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`formHint.${key}`);

  const navigate = useNavigate();

  return (
    <ResultPage
      buttonProps={{
        content: i18n("goToBindCard"),
        path: "../settings/bind-id-card",
      }}
      resultContent={`${i18n("youCanGo")} ${i18n("bindRoute")}，${i18n("view")}
      ${i18n("bindData")}`}
      resultText={i18n("pleaseGoToBindCard")}
      pageType="warning"
      pageTitle={i18n("goToBindCard")}
      children={children}
    />
  );
};

export default PleaseSetUserIDCard;
